import axios from 'axios';

const API_ROOT = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/api/mail', '')
  : 'http://localhost:3001';
const BASE = `${API_ROOT}/api/auth`;

export function getToken() { return localStorage.getItem('authToken'); }
export function getUser() {
  try { return JSON.parse(localStorage.getItem('authUser')); } catch { return null; }
}
export function setSession(token, user) {
  localStorage.setItem('authToken', token);
  localStorage.setItem('authUser', JSON.stringify(user));
}
export function clearSession() {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authUser');
}

export const login = (email, password) =>
  axios.post(`${BASE}/login`, { email, password }).then(r => r.data);

export const resetRequest = (email) =>
  axios.post(`${BASE}/reset-request`, { email }).then(r => r.data);

export const resetConfirm = (email, code, newPassword) =>
  axios.post(`${BASE}/reset-confirm`, { email, code, newPassword }).then(r => r.data);

export const changePassword = (currentPassword, newPassword) =>
  axios.post(`${BASE}/change-password`, { currentPassword, newPassword }, {
    headers: { Authorization: `Bearer ${getToken()}` },
  }).then(r => r.data);

export const getUsers = () =>
  axios.get(`${BASE}/users`, { headers: { Authorization: `Bearer ${getToken()}` } }).then(r => r.data);

export const createUser = (data) =>
  axios.post(`${BASE}/users`, data, { headers: { Authorization: `Bearer ${getToken()}` } }).then(r => r.data);

export const deleteUser = (email) =>
  axios.delete(`${BASE}/users/${encodeURIComponent(email)}`, { headers: { Authorization: `Bearer ${getToken()}` } }).then(r => r.data);

export const adminResetPassword = (email, newPassword) =>
  axios.post(`${BASE}/users/${encodeURIComponent(email)}/reset-password`, { newPassword }, {
    headers: { Authorization: `Bearer ${getToken()}` },
  }).then(r => r.data);

export const getSignature = () =>
  axios.get(`${BASE}/signature`, { headers: { Authorization: `Bearer ${getToken()}` } }).then(r => r.data.signature);

export const saveSignature = (signature) =>
  axios.post(`${BASE}/signature`, { signature }, { headers: { Authorization: `Bearer ${getToken()}` } }).then(r => r.data);
